import { gql } from '@apollo/client';
import { COMPANY_BASE_FIELDS } from '../fragments/company.fragments';
import { GROUP_BASE_FIELDS } from '../fragments/group.fragments';

export const GET_COMPANIES_EXTENDED = gql`
  query GetCompanies($input: GetCompaniesRequest!) {
    getCompanies(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        ...CompanyBaseFields
        client_bigquery_dataset
        client_bigquery_dataset_sync
        client_code
        group {
          ...GroupBaseFields
        }
      }
    }
  }
  ${COMPANY_BASE_FIELDS}
  ${GROUP_BASE_FIELDS}
`;

export const GET_COMPANIES = gql`
  query GetCompanies($input: GetCompaniesRequest!) {
    getCompanies(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        ...CompanyBaseFields
      }
    }
  }
  ${COMPANY_BASE_FIELDS}
`;
